<script>
  let { page, pageNumber, isDragging = false, onTap, onDelete, onDragStart, onDragEnd } = $props();
</script>

<div
  class="page-thumb"
  class:dragging={isDragging}
  onclick={onTap}
  role="button"
  tabindex="0"
  onkeydown={(e) => e.key === 'Enter' && onTap?.()}
>
  <div class="page-image-wrap">
    <span class="page-number">{pageNumber}</span>
    <button
      class="page-delete"
      aria-label="Delete page"
      onclick={(e) => {
        e.stopPropagation();
        onDelete?.();
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </button>
    <img src={page.thumbnail} alt="Page {pageNumber}" />
  </div>
  <div
    class="drag-handle"
    role="button"
    aria-label="Drag to reorder"
    tabindex="0"
    ontouchstart={onDragStart}
    ontouchend={onDragEnd}
    onmousedown={onDragStart}
    onmouseup={onDragEnd}
  >
    ⋮⋮
  </div>
</div>

<style>
  .page-thumb {
    position: relative;
    background: #374151;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    transition: transform 0.25s ease, opacity 0.2s;
    cursor: pointer;
  }

  .page-thumb:hover {
    transform: scale(1.02);
  }

  .page-thumb:active {
    transform: scale(0.98);
  }

  .page-thumb.dragging {
    opacity: 0.5;
    transform: scale(0.95);
    z-index: 100;
  }

  .page-image-wrap {
    position: relative;
    min-height: 0;
    overflow: hidden;
    aspect-ratio: 0.707; /* A4 ratio */
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1f2937;
  }

  .page-image-wrap img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
  }

  .page-number {
    position: absolute;
    top: 6px;
    left: 6px;
    background: rgba(0,0,0,0.7);
    color: white;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 999px;
    z-index: 2;
  }

  .page-delete {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(239, 68, 68, 0.9);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
  }

  .page-delete:hover {
    background: rgba(239, 68, 68, 1);
  }

  .drag-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    background: #1f2937;
    color: #9ca3af;
    font-size: 1.25rem;
    cursor: grab;
    touch-action: none;
    border-radius: 0 0 12px 12px;
    letter-spacing: 2px;
  }

  .drag-handle:active {
    cursor: grabbing;
    background: #374151;
  }
</style>
